import { render, staticRenderFns } from "./HistoriaNinoLink.vue?vue&type=template&id=35f9d563"
import script from "./HistoriaNinoLink.vue?vue&type=script&lang=js"
export * from "./HistoriaNinoLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports